import Vue from 'vue'
import VueRouter from 'vue-router'

import Auth from '../views/Auth.vue'

import InterfacePageDev from '../components/dev/Interface'
import Dashboard from '../views/Dashboard'
import Profile from '../views/profile/Profile'
import ProfileEdit from '../views/profile/Edit'
import Notifications from '../views/Notifications'
import About from '../views/About'
import Schedule from '../views/Schedule'
import Attendees from '../views/Attendees'
import Experts from '../views/Experts'

import libsTemplate from '../views/libs/_template'
import libsMaterials from '../views/libs/Materials'

import Token from '../views/Token'
import { metaAuth } from '@/utils/routes'
import SignUp from '../views/SignUp'
import PasswordReset from '../views/PasswordReset'
import ErrorPage from '@/views/ErrorPage'
import ScheduleEvent from '@/views/ScheduleEvent'
import ZoomLeave from '@/views/ZoomLeave'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/ui',
    redirect: '/dashboard',
  },
  {
    path: '/zoom-leave',
    component: ZoomLeave,
  },
  {
    path: '/ui',
    name: 'Interface',
    component: InterfacePageDev,
    meta: {
      langKey: 'interface',
    },
  },
  {
    path: '/auth',
    name: 'Auth',
    component: Auth,
    meta: {
      auth: false,
      navbar: false,
      menu: false,
      langKey: 'auth',
    },
  },
  {
    path: '/sign-up',
    name: 'Sign up',
    component: SignUp,
    meta: {
      auth: false,
      navbar: false,
      menu: false,
      langKey: 'sign-up',
    },
  },
  {
    path: '/password/reset/:token',
    name: 'Password reset',
    component: PasswordReset,
    meta: {
      auth: false,
      navbar: false,
      menu: false,
      langKey: 'password-reset',
    },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      navbar: 'dashboard',
      content: 'transparent dashboard',
      langKey: 'dashboard',
    },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { app: 'white', langKey: 'profile' },
  },
  {
    path: '/profile/edit',
    name: 'Profile edit',
    component: ProfileEdit,
    meta: { app: 'white', langKey: 'profile-edit' },
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: Notifications,
    meta: { content: 'transparent', langKey: 'notifications' },
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { content: 'transparent', langKey: 'about' },
  },
  {
    path: '/schedule/:day?',
    name: 'Schedule',
    component: Schedule,
    meta: { content: 'transparent', langKey: 'schedule' },
  },
  {
    path: '/schedule/:event/:name',
    name: 'ScheduleEvent',
    component: ScheduleEvent,
    meta: { content: 'transparent', langKey: 'schedule-event', paramTitle: 'name' },
  },
  {
    path: '/participants',
    name: 'Participants',
    component: Attendees,
    meta: { content: 'transparent', langKey: 'participants', role: 'attendee' },
  },
  {
    path: '/about/participants2020',
    name: 'Participants 2020',
    component: Attendees,
    meta: { content: 'transparent', summer2020: true, langKey: 'participants2020' },
  },
  {
    path: '/participants/:user',
    name: 'Participant details',
    component: Profile,
    meta: { backDesktop: true, app: 'white', langKey: 'participant-details' },
  },
  {
    path: '/administration/:user',
    name: 'Administration details',
    component: Profile,
    meta: { backDesktop: true, app: 'white', langKey: 'administration-details' },
  },
  {
    path: '/experts',
    name: 'Experts',
    component: Experts,
    meta: { content: 'transparent', langKey: 'experts' },
  },
  {
    path: '/experts/:user',
    name: 'Experts details',
    component: Profile,
    meta: { backDesktop: true, app: 'white', langKey: '', video: true },
  },
  {
    path: '/library/',
    name: 'Library',
    component: libsTemplate,
    meta: { content: 'transparent', langKey: 'experts-details' },
    children: [
      {
        name: 'Materials library in event',
        path: 'materials/:additional/event/:event',
        component: libsMaterials,
        meta: { langKey: 'materials-library-event' },
      },
      {
        name: 'Materials library',
        path: 'materials/:additional?/:experts?',
        component: libsMaterials,
        meta: { langKey: 'materials-library' },
      },
    ],
  },
  {
    path: '/token',
    name: 'Token',
    component: Token,
    meta: { auth: 'any', langKey: 'token' },
  },
  {
    path: '*',
    name: 'Error',
    component: ErrorPage,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: metaAuth(routes),
})

export default router
